import { publicComponentOption } from "dependencies/base"
import { toSelectOpt } from "utils"
const optDes = {
  ...publicComponentOption,
  textLimitLines: "字数限制个数",
  openBlankPage: "点击跳转方式",
  linkUrl: "跳转地址",
  accessRulers: "访问规则",
  startColor: "渐变色开始色值",
  endColor: "渐变色结束色值",
  colorlinearGradientAngle: "渐变色渐变角度",

}
export const getOptDes = toSelectOpt.bind(this, optDes)
